module.exports = __webpack_public_path__ + "static/media/nirveda-hero-logo.83330ed5.png";